import { render, staticRenderFns } from "./SubDistrictAddress.vue?vue&type=template&id=3bb3cafa&scoped=true"
import script from "./SubDistrictAddress.vue?vue&type=script&lang=js"
export * from "./SubDistrictAddress.vue?vue&type=script&lang=js"
import style0 from "./SubDistrictAddress.vue?vue&type=style&index=0&id=3bb3cafa&prod&lang=scss&scoped=true"
import style1 from "./SubDistrictAddress.vue?vue&type=style&index=1&id=3bb3cafa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb3cafa",
  null
  
)

export default component.exports